var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.330078C2.23858 0.330078 0 2.56866 0 5.33008V24.67C0 27.4314 2.23858 29.67 5 29.67H20.0252C22.7867 29.67 25.0252 27.4314 25.0252 24.67V5.33008C25.0252 2.56865 22.7866 0.330078 20.0252 0.330078H5ZM10.0251 12.6529V19.4994C10.0251 21.7923 10.0253 24.0861 10.0256 26.3807C10.0256 26.7899 10.2682 27 10.7431 27H14.2981C14.7862 27 15.0251 26.7899 15.0251 26.3698V12.6273C15.0251 12.205 14.7871 12 14.2973 12H10.7817C10.2485 12 10.0251 12.1929 10.0251 12.6529ZM17.0254 21.5045V16.6575C17.0254 16.1997 17.2536 16 17.777 16H21.3121C21.778 16 22.0251 16.2157 22.0251 16.623V26.3852C22.0251 26.78 21.7735 26.9996 21.3223 27H17.7286C17.277 27 17.0258 26.7813 17.0254 26.3857C17.0251 24.7583 17.0251 23.1313 17.0254 21.5045ZM3.02629 20.6558V23.4998C3.02492 24.4537 3.02478 25.408 3.02588 26.3626C3.0267 26.7598 3.28081 27 3.70405 27H7.33712C7.77227 26.9995 8.02515 26.762 8.02515 26.3525V20.6466C8.02515 20.2361 7.7735 20 7.33671 20H3.72416C3.2726 20 3.02629 20.2306 3.02629 20.6558Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReporting);
export default __webpack_public_path__ + "static/media/icon_reporting.97d6a5ca5df1bb0c0f406831a7c2d478.svg";
export { ForwardRef as ReactComponent };